import get from 'lodash/get'
import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

const AccountView = () => import('../views/AccountView.vue')
const AccountChangePasswordView = () => import('../views/Account/ChangePasswordView')
const AccountDetailsView = () => import('../views/Account/DetailsView')
const GameServerIndexView = () => import('../views/GameServerIndexView.vue')
const HomeView = () => import('../views/HomeView.vue')
const PageNotFoundView = () => import('../views/PageNotFoundView.vue')
const ServerCreateView = () => import('../views/ServerCreateView.vue')
const ServerShowView = () => import('../views/ServerShowView.vue')
const UserCreateView = () => import('../views/UserCreateView.vue')
const UserTokenCreateView = () => import('../views/UserTokenCreateView.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'userToken.create',
    component: UserTokenCreateView,
    meta: {
      accessibleTo: [
        'guest',
      ],
    },
  },
  {
    path: '/register',
    name: 'user.create',
    component: UserCreateView,
    meta: {
      accessibleTo: [
        'guest',
      ],
    },
  },
  {
    path: '/account/details',
    name: 'account.details',
    component: AccountView,
    meta: {
      accessibleTo: [
        'user',
      ],
    },
    props: {
      childComponent: AccountDetailsView,
    },
  },
  {
    path: '/account/change-password',
    name: 'account.changePassword',
    meta: {
      accessibleTo: [
        'user',
      ],
    },
    component: AccountView,
    props: {
      childComponent: AccountChangePasswordView,
    },
  },
  {
    path: '/g/:gameIdentifier/servers',
    name: 'gameServer.index',
    component: GameServerIndexView,
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/servers/create',
    name: 'server.create',
    component: ServerCreateView,
  },
  {
    path: '/servers/:serverId',
    name: 'server.show',
    component: ServerShowView,
  },
  {
    path: '*',
    name: 'pageNotFound',
    component: PageNotFoundView,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.app.isInitialized) {
    await store.dispatch('auth/init')
    store.commit('app/setIsInitialized', true)
  }

  const isAuthenticated = !!store.state.auth.token

  const accessibleTo = get(to, 'meta.accessibleTo', [
    'guest',
    'user',
  ])

  if (!accessibleTo.includes(isAuthenticated ? 'user' : 'guest')) {
    next({ name: isAuthenticated ? 'server.index' : 'userToken.create' })
    return
  }

  next()
})

export default router
